module.exports = __webpack_public_path__ + "static/media/jucara.45b835f9.jpeg";